/**
 * MultiplayerVictory — winner announcement modal.
 */

import { useState, useCallback } from 'react';

export default function MultiplayerVictory({
  winnerName,
  winnerId,
  mySocketId,
  winningWord,
  onReturnToLobby,
  onViewGraph,
  isHost,
}) {
  const isMe = winnerId === mySocketId;
  const [copied, setCopied] = useState(false);

  const handleShare = useCallback(() => {
    const word = (winningWord || '').replace(/\b\w/g, c => c.toUpperCase());
    const who = isMe ? 'I won' : `${winnerName} won`;
    const text = `LexiQuest Multiplayer: ${who}! Target: ${word}\nhttps://lexiquest.app`;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  }, [winningWord, isMe, winnerName]);

  return (
    <div className="modal-overlay">
      <div className="modal accent-exceptional">
        <div className="modal-title">Quest Complete</div>
        <div className={`modal-rating ${isMe ? 'exceptional' : 'great'}`}>
          {isMe ? 'You Win!' : `${winnerName} Wins!`}
        </div>

        <div className="modal-score-display">
          <div className="mp-winning-word">{winningWord}</div>
          <span className="modal-score-unit">target word found</span>
        </div>

        <div className="modal-buttons">
          {isHost && (
            <button className="btn-new" onClick={onReturnToLobby}>
              Return to Lobby
            </button>
          )}
          <button className="btn-share" onClick={handleShare}>
            {copied ? 'Copied!' : 'Share Result'}
          </button>
          <button className="btn-view-graph" onClick={onViewGraph}>
            View Graph
          </button>
        </div>
      </div>
    </div>
  );
}
